<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>站内公告</span>
      </div>

      <el-form :inline="true" :model="formSearch" class="demo-form-inline" size="mini">
        <el-form-item label="标题">
          <el-input v-model="formSearch.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" size="mini">
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="fileName" label="附件">
          <template slot-scope="scope">
            <el-button @click="handleDownload(scope.row)" type="text" size="small">{{scope.row.fileName}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state == '0'" type="success">未读</el-tag>
            <el-tag v-if="scope.row.state == '1'" type="success">已读</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleShowClick(scope.row)" type="text" size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="float:right;margin:10px"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageresult.pageSize"
        layout="total, prev, pager, next"
        :total="pageresult.totalSize">
      </el-pagination>
    </el-card>

    <el-drawer :visible.sync="drawerShow" :with-header="false" size="90%">
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <span>公告详细</span>
        </div>

        <el-form :model="showForm" label-width="100px" size="mini">
          <el-form-item label="标题" prop="title">
            <div style=" border:1px solid #CCCCCC;">{{ showForm.title }}</div>
          </el-form-item>
          <el-form-item label="附件">
            <el-button @click="handleDownload(showForm)" type="text" size="small">{{ showForm.fileName }}</el-button>
          </el-form-item>
          <el-form-item label="内容">
            <div style="border:1px solid #CCCCCC;min-height:100px;" v-html="showForm.content"></div>
          </el-form-item>
        </el-form>
      </el-card>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment'
import E from 'wangeditor'
export default {
  data () {
    return {
      myHeaders:{},
      editor: null,
      pageresult:{},
      showForm:{},
      ruleForm: {
        title: '',
        content:''
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ]
      },
      drawer: false,
      drawerShow: false,
      formSearch: {
        title: '',
        merchNo:'',
        pageNum:1
      },
      tableData:[],
    }
  },
  created(){
    var token =  window.sessionStorage.getItem('token');
    this.myHeaders = {'oa-token':token}
    let info = this.$store.state.userInfo;
    this.formSearch.merchNo = info.userbh;
    this.search();
  },
  mounted(){

  },
  methods: {
    handleAvatarCouponUserSuccess(res, file){
      if (res.code == 0) {
        this.ruleForm.fileName = res.data.fileName
        this.ruleForm.filePath = res.data.filePath
        this.$alert('上传成功!', '提示', {
          confirmButtonText: '确定',
        });
      }
    },
    handdleSite(){
      this.drawer = true;
    },
    handleOpened(){
      if (this.editor == null) {
        this.editor = new E(this.$refs.editorElem);
        // 编辑器的事件，每次改变会获取其html内容
        this.editor.customConfig.onchange = html => {
          this.ruleForm.content = html;
          // 把这个html通过catchData的方法传入父组件//
        };
        this.editor.customConfig.menus = [
          // 菜单配置
          'head', // 标题
          'bold', // 粗体
          'fontSize', // 字号
          'fontName', // 字体
          'italic', // 斜体
          'underline', // 下划线
          'strikeThrough', // 删除线
          'foreColor', // 文字颜色
          'backColor', // 背景颜色
          'link', // 插入链接
          'list', // 列表
          'justify', // 对齐方式
          'quote', // 引用
          'emoticon', // 表情
          'image', // 插入图片
          'table', // 表格
          'code', // 插入代码
          'undo', // 撤销
          'redo' // 重复
        ];
        this.editor.customConfig.uploadImgShowBase64 = true   // 使用 base64 保存图片
        this.editor.create(); // 创建富文本实例
      }
    },
    handleShowClick(row){
      let _this = this;
      _this.$ajax({
        url:"coupon-system/site/upd",
        async:false,
        data:{ 'id':row.siteId },
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code==0) {
            _this.showForm = row;
            _this.drawerShow = true;
            _this.search();
          }else{
            _this.$message.error(response.message);
          }
        }
      })
    },
    handleCurrentChange(val) {
      this.formSearch.pageNum = val;
      this.search();
    },
    formatDate(row, column) {
      return moment(row.createdate).format("YYYY-MM-DD HH:mm");
    },
    submitForm(){
      let that = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$ajax({
            url:"/coupon-system/site/add",
            async:false,
            methods:'POST',
            data:that.ruleForm,
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                that.ruleForm = {};
                that.drawer=false;
                that.search();
                that.resetForm('ruleForm');
              }else{
                that.$message.error(response.message);
              }
            }
          })
        } else {
          that.$message.error('error submit!!');
          return false;
        }
      });

    },
    resetForm(formName) {
      this.editor.txt.clear();
      this.$refs[formName].resetFields();
    },
    search(){
      let that = this;
      this.$ajax({
        url:"coupon-system/site/mer/list",
        async:false,
        data:that.formSearch,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            that.tableData=response.data.content;
            that.pageresult = response.data;
          }else{
            that.$message.error(response.message);
          }
        }
      })
    },
    handleDownload(row){
      this.$download('coupon-system/site/download',{'filePath':row.filePath,'fileName':row.fileName}).then((res) => {
        this.download(res,row.fileName);
      }).catch(err => {
        this.$message.error("下载失败");
      })
    },
    // 下载文件
    download (data,fileName) {
        if (!data) {
            return;
        }
        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.target = "_blank";
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/merch/mer_site.vue